
  import {Component, Prop, Vue, Model, Watch} from "vue-property-decorator";
  import {AttachmentDto, AttachmentHostType} from "@/api/appService";
  import api from '@/api/index'
  import {interfaceTemplate} from "swagger-vue-codegen/dist/templates/template";

  interface FileItem{
    id:number,
    name:string,
    url:string
  }

  @Component({name:"BatchUpload"})
  export default class BatchUpload extends  Vue{

    @Model('change')readonly attachments!:number[];

    @Prop({required:true})
    hostId!:string | number;

    @Prop({required:true})
    hostType!:AttachmentHostType;


    private savedAttachments:number[] = [];
    private existsFileList:FileItem[] = [];
    private eventId = '';

    get uploadParameter(){
      return {hostType:this.hostType};
    }

    get headers(){
      return {
        'Abp-OrganizationUnitId':this.$store.getters['user/ouId'],
        'Abp-ManagePlatform':true,
        'Abp-TenantId':this.$store.getters['app/tenantId'],
        'Authorization':`Bearer ${this.$store.getters['user/token']}`,
        '.AspNetCore.Culture':'c=zh-Hans|uic=zh-Hans'
      }
    }

    @Watch('hostId')
    onHostIdChange(){
      console.log('<batch-upload> hostId change')
      this.loadExistsAttachments();
    }

    @Watch('hostType')
    onHostTypeChange(){
      this.loadExistsAttachments();
    }

    @Watch('attachments')
    onModelChange(newValue:number[]){

      console.log(`<batch-upload>, attachments updated ${this.eventId} ${newValue}`);
      this.eventId = '';
    }


    reset(){
      console.log('<batch-upload>, reset')
      this.existsFileList = [];
      this.savedAttachments = [];
      this.$emit('change',[]);
    }


    async created(){
      await this.loadExistsAttachments();
    }

    async loadExistsAttachments(){
      if(this.hostId === 0 || this.hostId === '' || this.hostId === '0'){
        this.reset()
        return;
      }
      await api.attachmentService.getAttachments({hostId:this.hostId.toString(),hostType:this.hostType}).then(res=>{

        if(res){

          this.existsFileList = res.map(attachment=>{
            return {
              id:attachment.id!,
              url:attachment.url!,
              name:attachment.fileName!
            }
          });
          this.savedAttachments = res.map(attachment=>attachment.id!);
        } else {
          this.existsFileList = [];
          this.savedAttachments = [];
        }

        this.eventId = (Math.random().toString());
        console.log(`<batch-upload> $emit change in loadExistsAttachments ${this.eventId} ${this.savedAttachments}`);

        setTimeout(()=>{
          this.$emit('change',this.savedAttachments);
        },300);

      })
    }


    async handleSuccess(res: any, file: any) {
      if (res.success) {
        this.savedAttachments = [...this.savedAttachments,res.result.attachmentId];
        this.$emit('change',this.savedAttachments);
      }
    }

    async handleRemove(file: any, fileList: any) {
      let newValue:number[] = [];
      for(let i = 0;i<this.savedAttachments.length;i++){
        let id = this.savedAttachments[i];
        if(id!==file.id){
          newValue.push(id);
        }
      }
      this.savedAttachments = newValue;
      this.$emit('change',this.savedAttachments);
    }

  }

